import { ActionType, Lookups, ConversionRequired } from "../models/Enums";
import { SaveRecentSearchAuth } from "../services/AuthServices";
import { format } from "date-fns";

// A patient synced from PCC (or any external integration) has its identity/contact
// fields owned by that system. Locked until the integration record is explicitly
// accepted (integrationStatus / notes flow), so edits here don't drift from PCC.
export function getPatientIntegrationLock(patient: any) {
  const isIntegrationPatient =
    !!patient?.integrationExternalPendingId ||
    Number(patient?.integrationExternalApprovedId) > 0;
  const isIntegrationAccepted =
    patient?.integrationExternalPendingId != null &&
    Number(patient?.integrationExternalApprovedId) > 0 &&
    patient?.integrationStatus !== 4 &&
    patient?.notes === "AcceptedByIntegration";

  return {
    // First name / last name / DOB / mobile phone
    disableIdentityFields: isIntegrationPatient && !isIntegrationAccepted,
    // Email (and admit/discharge/room when they exist on a given screen)
    disableIntegrationOnlyFields: isIntegrationPatient,
  };
}

export function getHeaderText(Header: Lookups) {
  if (Header == Lookups.Setting) {
    return "Setting";
  } else if (Header == Lookups.Referral) {
    return "Referral";
  } else if (Header == Lookups.Physician) {
    return "Physician";
  } else if (Header == Lookups.Tags) {
    return "Tags";
  } else if (Header == Lookups.Diagnosis) {
    return "Diagnosis";
  } else if (Header == Lookups.Department) {
    return "Department";
  } else if (Header == Lookups.Role) {
    return "Role";
  } else if (Header == Lookups.Medications) {
    return "Medications";
  }
}
export function validationNamePattern(Name: string) {
  if (Name == "") {
    return { isSuccess: true, error: "" };
  }
  let spStart = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
  let dateValues = Name.match(spStart);
  if (dateValues != null) {
    return {
      isSuccess: false,
      error: "Data name should start with alphanumeric",
    };
  }
  let pattern = /^[a-zA-Z0-9]{1}([_@.#$%^&\- a-zA-Z0-9])*$/;
  dateValues = Name.match(pattern);
  if (dateValues == null) {
    return { isSuccess: false, error: "Invalid Data name" };
  } else {
    return { isSuccess: true, error: "" };
  }
}
export function verifiyNameWithPattern(Name: string) {
  debugger;
  if (Name == "") {
    return { isSuccess: true, error: "" };
  }
  // let pattern =/^[a-z0-9]+$/i;
  // let pattern = /^[A-Za-z0-9][^<>:"|\\/?*£]*$/;
  let pattern = /^[0-9a-zA-Z][\w\d\.]{1,50}$/i;
  // let pattern =/^[A-Za-z0-9]^[<>:"|\\/?*]*$/;
  let isNameValid = pattern.test(Name);
  if (!isNameValid) {
    return { isSuccess: false, error: "Invalid Data name" };
  } else {
    return { isSuccess: true, error: "" };
  }
}
export function verifiyDoBWithPattern(Name: string) {
  if (Name == "") {
    return { isSuccess: true, error: "" };
  }
  if (Name.length >= 10) {
    const pattern = new RegExp("([0-9]{2})/([0-9]{2})/([0-9]{4})");
    let dateValues = pattern.test(Name);
    if (!dateValues) {
      return {
        isSuccess: false,
        error: "Date pattern Doesn't Match It should be like (11/11/1111)",
      };
    } else {
      return { isSuccess: true, error: "" };
    }
  } else {
    return {
      isSuccess: false,
      error: "Date incomplete It should be like (11/11/1111)",
    };
  }
}
export function numberValidation(code: string) {
  if (code == "") {
    return { isSuccess: true, error: "" };
  }
  if (code.length <= 10) {
    const reg = /^\d+$/;
    let dateValues = reg.test(code);
    if (!dateValues) {
      return { isSuccess: false, error: "must be in numeric " };
    } else {
      return { isSuccess: true, error: "" };
    }
  } else {
    return { isSuccess: false, error: "is too large" };
  }
}

export function getParmeters(
  LookUpType: Lookups,
  labelName: string,
  id: number,
) {
  if (LookUpType == Lookups.Setting) {
    return {
      body: {
        applicationLookup: 5,
        localDateTime: new Date(),
        tags: {
          id: id,
          tagName: labelName,
        },
      },

      url: "/Lookups",
    };
  } else if (LookUpType == Lookups.Referral) {
    return {
      body: {
        applicationLookup: 5,
        localDateTime: new Date(),
        team: {
          id: id,
          name: labelName,
        },
      },

      url: "/Lookups/AddUpdateReferralSource",
    };
  } else if (LookUpType == Lookups.Physician) {
    return {
      body: {
        applicationLookup: 5,
        localDateTime: new Date(),
        subGroup: {
          id: id,
          groupId: 0,
          name: labelName,
        },
      },

      url: "/Lookups/AddUpdatePhysician",
    };
  } else if (LookUpType == Lookups.Tags) {
    return {
      body: {
        applicationLookup: 5,
        localDateTime: new Date(),
        tags: {
          id: id,
          tagName: labelName,
        },
      },

      url: "/Lookups/AddUpdateTag",
    };
  } else if (LookUpType == Lookups.Diagnosis) {
    return {
      body: {
        applicationLookup: 5,
        localDateTime: new Date(),
        tags: {
          id: id,
          tagName: labelName,
        },
      },

      url: "/Lookups",
    };
  } else if (LookUpType == Lookups.Department) {
    return {
      body: {
        applicationLookup: 5,
        localDateTime: new Date(),
        group: {
          id: id,
          teamId: id,
          name: labelName,
        },
      },

      url: "/Lookups/AddUpdateDepartment",
    };
  } else if (LookUpType == Lookups.Role) {
    return {
      body: {
        applicationLookup: 5,
        localDateTime: new Date(),
        clinicianRole: {
          id: id,
          roleName: labelName,
        },
      },
      url: "/Lookups/AddUpdateRole",
    };
  }
}

export function FormatedMobileNumber(mobile: string) {
  return (
    mobile.slice(0, 3) +
    "-" +
    mobile.slice(3, 6) +
    "-" +
    mobile.slice(6, mobile.length)
  );
}
export function getFormatedMobileNumber(mobile: string) {
  if (mobile != "" && mobile != undefined && mobile != null) {
    if (mobile.indexOf("-") > -1) {
      return mobile;
    } else {
      if (mobile.length >= 10) {
        return FormatedMobileNumber(mobile);
      } else {
        return mobile;
      }
    }
  } else {
    return "";
  }
}

export function getFormattedTimeForTicks(ticks: string) {
  var s = new Date(parseInt(ticks)),
    dformat =
      s.toISOString().slice(0, 10) +
      " " +
      [s.getHours(), s.getMinutes(), s.getSeconds()].join(":");
  return dformat;
}

export function getPatientAge() {
  if (localStorage.getItem("patientdob")!) {
    return convertDOBintoAge(new Date(localStorage.getItem("patientdob")!));
  }
  return 45;
}

export function convertDOBintoAge(dob: Date) {
  // console.log("DOB:  ", dob);
  if (!dob || isNaN(dob.getTime())) return 0;
  var diff_ms = Date.now() - dob.getTime();
  var age_dt = new Date(diff_ms);
  // console.log("AGE CALCULATED:  ", Math.abs(age_dt.getUTCFullYear() - 1970));
  return Math.abs(age_dt.getUTCFullYear() - 1970);
}
export function graphGaitAndStepLengthNormValue(age: number, graph: String) {
  if (age >= 6 && age <= 12)
    return graph == "GaitSpeed" ? 1.13 : Math.floor(0.58 * 100);
  else if (age >= 13 && age <= 19)
    return graph == "GaitSpeed" ? 1.22 : Math.floor(0.68 * 100);
  else if (age >= 20 && age <= 69)
    return graph == "GaitSpeed" ? 1.32 : Math.floor(0.66 * 100);
  else if (age >= 70 && age <= 74)
    return graph == "GaitSpeed" ? 1.16 : Math.floor(0.61 * 100);
  else if (age >= 75 && age <= 79)
    return graph == "GaitSpeed" ? 1.12 : Math.floor(0.59 * 100);
  else if (age >= 80 && age <= 84)
    return graph == "GaitSpeed" ? 1.01 : Math.floor(0.55 * 100);
  else if (age >= 85)
    return graph == "GaitSpeed" ? 0.98 : Math.floor(0.54 * 100);
}

export function localDateTime() {
  return new Date(
    new Date().setHours(
      new Date().getHours() - new Date().getTimezoneOffset() / 60,
    ),
  ).toISOString();
}
export function convertUnit(val: any, conversionRequired: ConversionRequired) {
  const valType = typeof val === "number" ? "number" : typeof val;

  switch (conversionRequired) {
    case ConversionRequired.MeterToInches: {
      const valMeter = parseFloat(val);
      const valInches = valMeter * 39.3701;

      return convertType(valInches, valType);
    }

    case ConversionRequired.MeterToCentiMeter: {
      const valMeter = parseFloat(val);
      const valCentiMeter = valMeter * 100.001;

      return convertType(valCentiMeter, valType);
    }

    case ConversionRequired.MeterToFeet: {
      const valInches = parseFloat(
        convertUnit(val, ConversionRequired.MeterToInches),
      );
      const feet =
        Math.floor(valInches / 12).toString() +
        "'" +
        (valInches % 12).toFixed(2).toString() +
        "''";

      return feet;
    }

    case ConversionRequired.NewtonToPounds: {
      const valNewton = parseFloat(val);
      const valPounds = valNewton * 0.2248;

      return convertType(valPounds, valType);
    }

    case ConversionRequired.MilliSecToSeconds: {
      const milliSec = parseFloat(val);
      const seconds = milliSec / 1000;

      return convertType(seconds, valType);
    }

    case ConversionRequired.CentimeterToMeter: {
      const valMeter = parseFloat(val);
      const valCentiMeter = valMeter / 100;

      return convertType(valCentiMeter, valType);
    }

    case ConversionRequired.CentimeterToInches: {
      const valMeter = parseFloat(val);
      const valCentiMeter = valMeter * 0.393701;

      return convertType(valCentiMeter, valType);
    }

    default:
      return val;
  }
}

function convertType(value: any, type: any) {
  switch (type) {
    case "number":
      return parseFloat(value);
    case "string":
      return value.toString();
    default:
      return value;
  }
}

//Function to convert date to MM/DD/YYYY format
export function formatDate(dateString: string): string {
  if (!dateString) return "";
  const parts = String(dateString).split(" ");
  const month = parts[0];
  const day = parseInt(parts[1], 10);
  const year = parseInt(parts[2], 10);
  // Convert month abbreviation to numerical representation
  const monthNumerical =
    new Date(Date.parse(month + " 1, 2000")).getMonth() + 1;
  // Pad day and month with leading zeros if needed
  const formattedDay = day < 10 ? "0" + day : day;
  const formattedMonth =
    monthNumerical < 10 ? "0" + monthNumerical : monthNumerical;
  return `${formattedMonth}/${formattedDay}/${year}`;
}

export function convertISOToReadableDate(isoDateString: string): string {
  const date = new Date(isoDateString);
  if (isNaN(date.getTime())) return "";
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  return `${month} ${day} ${year}`;
}

export function CurrDatetimeInNewFormat(inTime: Date) {
  let month = ("0" + (inTime.getMonth() + 1)).slice(-2); // Add leading zero to month
  let day = ("0" + inTime.getDate()).slice(-2); // Add leading zero to day
  let hours = ("0" + inTime.getHours()).slice(-2); // Add leading zero to hours
  let minutes = ("0" + inTime.getMinutes()).slice(-2); // Add leading zero to minutes
  let seconds = ("0" + inTime.getSeconds()).slice(-2); // Add leading zero to seconds

  let crrTime =
    inTime.getFullYear() +
    "-" +
    month + // Use formatted month
    "-" +
    day + // Use formatted day
    "T" +
    hours + // Use formatted hours
    ":" +
    minutes + // Use formatted minutes
    ":" +
    seconds; // Use formatted seconds

  return crrTime;
}

export function sortTests(exercises: any, duplicateExercisesId: any) {
  debugger;
  if (!Array.isArray(exercises)) {
    return exercises;
  }
  // Clone the array to avoid mutating state directly
  const clonedArr: any = [...exercises];

  return clonedArr.sort((a: any, b: any) => {
    const aInSortList = duplicateExercisesId.includes(a.testExercises[0].id);
    const bInSortList = duplicateExercisesId.includes(b.testExercises[0].id);

    const aHasFlag =
      a.testExercises[0].ismCTSIB ||
      a.testExercises[0].isReach ||
      a.testExercises[0].isGait ||
      a.testExercises[0].is5XSTS ||
      a.testExercises[0].isTug;

    const bHasFlag =
      b.testExercises[0].ismCTSIB ||
      b.testExercises[0].isReach ||
      b.testExercises[0].isGait ||
      b.testExercises[0].is5XSTS ||
      b.testExercises[0].isTug;

    // Priority 1: In sort list & has a flag → highest priority
    if (aInSortList && aHasFlag && !(bInSortList && bHasFlag)) return -1;
    if (bInSortList && bHasFlag && !(aInSortList && aHasFlag)) return 1;

    // Priority 2: Has a flag but not in sort list → second priority
    if (aHasFlag && !bHasFlag) return -1;
    if (bHasFlag && !aHasFlag) return 1;

    // Priority 3: ID is in sort order → third priority
    const aIndex = duplicateExercisesId.indexOf(a.testExercises[0].id);
    const bIndex = duplicateExercisesId.indexOf(b.testExercises[0].id);

    if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
    if (aIndex !== -1) return -1;
    if (bIndex !== -1) return 1;

    return 0;
  });
}

export const getCurrentDay = () => {
  let d = new Date();
  let dayName = d.toString().split(" ");
  return dayName.slice(0, 2).join(", ") + " " + dayName.slice(2, 4).join(", ");
};

export function formatAMPM(date: any) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
}

export const getLocalStringDate = () => {
  let date = new Date();
  return date.toLocaleDateString();
};

export function toLocalISOString(date: Date): string {
  const pad = (n: number) => n.toString().padStart(2, "0");

  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    "T" +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes()) +
    ":" +
    pad(date.getSeconds())
  );
}

export function formatDateToMMDDYYYY(date: string | Date): string {
  const dateObj = typeof date === "string" ? new Date(date) : date;

  const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
  const day = dateObj.getDate().toString().padStart(2, "0");
  const year = dateObj.getFullYear();

  return `${month}/${day}/${year}`;
}

export function convertTo12HourFormat(time24: string): string {
  const [hours, minutes] = time24.split(":").map(Number);

  const period = hours >= 12 ? "PM" : "AM";
  const hours12 = hours % 12 || 12;
  const formattedHours = hours12.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");

  return `${formattedHours}:${formattedMinutes} ${period}`;
}

export function parseDateTime(datePart: string, time12h: string): Date {
  const [time, modifier] = time12h.split(" "); // ["02:03", "AM"]
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours !== 12) {
    hours += 12;
  }
  if (modifier === "AM" && hours === 12) {
    hours = 0;
  }

  // Create a valid ISO string with time included
  const isoString = `${datePart}T${String(hours).padStart(2, "0")}:${String(
    minutes,
  ).padStart(2, "0")}:00`;
  return new Date(isoString);
}

export const testTypeMappings: { [key: string]: number } = {
  none: 0,
  ctsib: 1,
  reach: 2,
  training: 3,
  ybalance_upper: 4,
  ybalance_lower: 5,
  vertical_jump: 6,
  hop_double_leg: 7,
  deep_squat: 8,
  hurdle_step: 9,
  in_line_lunge: 10,
  shoulder_mobility: 11,
  straight_leg_raise: 12,
  trunk_punshup: 13,
  rotary_stability: 14,
  height_measure: 15,
  ctsib_single_leg_left: 16,
  ctsib_single_leg_right: 17,
  sensory_organization: 18,
  sensory_organization_training_store: 19,
  sensory_organization_training_street: 20,
  hec_training: 21,
  gait: 22,
  tinetti_balance: 23,
  tinetti_gait: 24,
  bess: 25,
  cognitive: 26,
  berg_scripted: 27,
  deep_squat_smart: 28,
  box_jump: 29,
  excursion_lower: 30,
  tug: 31,
  als: 32,
  amp_scripted: 33,
  amp_scripted_no: 34,
  five_x_sit_stand: 35,
  marker_based_gait: 36,
  sitting_reach: 37,
  game_lean: 38,
  game_reach: 39,
  game_speed: 40,
  veggie_samurai: 41,
  simon_says_game: 42,
  aerobics_game: 43,
  sequence_game: 44,
  memory_game: 45,
  steadi: 46,
  timed_sit_stand: 47,
  four_stage_balance: 48,
  sensory_organization_training: 49,
  game_AF: 50,
  red_light_green_light: 51,
  upper_body_arom: 55,
  functional_reach: 56,
  game_BalloonPopper: 58,
};

export const utcToLocalDate = (
  utcDateStr: string | null | undefined,
): Date | null => {
  if (!utcDateStr) return null;

  let normalized = utcDateStr.trim();

  // Normalize MM/DD/YYYY HH:MM:SS → ISO 8601 (YYYY-MM-DDTHH:MM:SS) before appending Z
  const mmddyyyyMatch = normalized.match(
    /^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}:\d{2}:\d{2})$/,
  );
  if (mmddyyyyMatch) {
    const [, mm, dd, yyyy, time] = mmddyyyyMatch;
    normalized = `${yyyy}-${mm}-${dd}T${time}`;
  }

  // Append 'Z' to force UTC interpretation — the API returns strings without timezone offset
  if (!normalized.endsWith("Z")) {
    normalized = `${normalized}Z`;
  }

  const date = new Date(normalized);
  return isNaN(date.getTime()) ? null : date;
};

// Date values coming back from the API can be null, empty or unparsable (patients
// imported without a DOB, visits with no date). Passing those to date-fns `format`
// throws "RangeError: Invalid time value" and blanks the whole page, so every
// render-time date goes through this instead.
export function toValidDate(value: any): Date | null {
  if (value === null || value === undefined || value === "") return null;
  const date = value instanceof Date ? value : new Date(value);
  return isNaN(date.getTime()) ? null : date;
}

export function safeFormatDate(
  value: any,
  dateFormat: string = "MM/dd/yyyy",
  fallback: string = "",
): string {
  const date = toValidDate(value);
  if (!date) return fallback;
  try {
    return format(date, dateFormat);
  } catch {
    return fallback;
  }
}
